import { Search } from "lucide-react";
import type { SearchFieldProps } from "../types/layout.js";

export function SearchField({ label, controlId, className = "", ...props }: SearchFieldProps) {
  return (
    <label className={`relative block ${className}`}>
      <span className="sr-only">{label}</span>
      <Search
        aria-hidden="true"
        className="pointer-events-none absolute left-4 top-3 size-5 text-muted-foreground"
      />
      <input
        className="min-h-11 w-full rounded-xl border border-input bg-background pl-11 pr-4 text-sm shadow-xs focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/30"
        data-control-id={controlId}
        placeholder={label}
        type="search"
        {...props}
      />
    </label>
  );
}
